<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Rangepicker</h1>
  </div>
</div>

<div class="row">
  <div class="col-12 col-sm-6">
    <div class="button-row">
      <ui-platform-rangepicker></ui-platform-rangepicker>
    </div>
  </div>
</div>
